import { TableBodyBaseRow } from "./TableBodyBaseRow"
import { useIntersectionObserver } from "../../../../hooks/useIntersectionObserver"

import type { HTMLAttributes } from "react"

export interface TableBodyRowProps extends HTMLAttributes<HTMLTableRowElement> {
  onIntersect?: () => void
  isSelected?: boolean
  enableRowHighlighting?: boolean
  rowKey: string
}

// Every row renders the same component so that a row gaining or losing
// onIntersect (only the last row observes, for infinite scroll) does not
// remount it and drop its focus.
export function TableBodyRow({
  onIntersect,
  ...otherProps
}: TableBodyRowProps) {
  const ref = useIntersectionObserver<HTMLTableRowElement>(onIntersect)
  return <TableBodyBaseRow ref={ref} {...otherProps} />
}
